export const WEB_API_LOG_IN = "getAuthToken";

export const GET_USER = "getUser";

export const LOG_OUT = "logOut";
